import { render, staticRenderFns } from "./keyPersonTable.vue?vue&type=template&id=1e31410f&"
import script from "./keyPersonTable.vue?vue&type=script&lang=js&"
export * from "./keyPersonTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports